// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__HMb0T","signatureButtonsRight":"ModalSign_signatureButtonsRight__1xZZK"};